import { typeGuard } from '../../utils';
import { getSerializeQueryArgs } from './getSerializeQueryArgs';
import { addMutationEndpoints } from './mutations/addMutationEndpoints';
import { addQueryEndpoints } from './queries/addQueryEndpoints';
export const createApiSlice = (createRtkQueryApi) => createRtkQueryApi({
    reducerPath: 'sfApi',
    baseQuery: apiSliceBaseQuery(),
    tagTypes: typeGuard(['Event', 'Index', 'Stream', 'Token']),
    endpoints: (builder) => ({
        ...addQueryEndpoints(builder),
        ...addMutationEndpoints(builder),
    }),
    serializeQueryArgs: getSerializeQueryArgs(),
});
export function apiSliceBaseQuery() {
    return function () {
        throw new Error('All queries & mutations must use the `queryFn` definition syntax.');
    };
}
//# sourceMappingURL=sfApiSlice.js.map